import React, { useEffect, useState } from 'react';
import DropDownSelect from '../../../../../components/DropDownSelect/index';
import DropDownScroll from '../../../../../components/DropDownScroll/index';
import { Col, Row } from 'react-bootstrap';
import SkeletonGrid from '../../../../../components/SkeletonLoader/SkeletonGrid';
import 'react-datepicker/dist/react-datepicker.css';
import { 
  useGetAssignmentStudentsListMutation,
  useGetAssignmentClassesMutation 
} from '../../../../../features/authentication/reportApiSlice';
import CustomToast from '../../../../../components/Toast';
import { useNavigate, useParams } from 'react-router';
import { useGetAssignmentBasicMutation } from '../../../../../features/authentication/assignmentApislice';

const SingleAssessmentFilters = () => {
  let takeSize = 30;
  const [getAssignmentStudents, {isLoading : isStudentsLoading}] = useGetAssignmentStudentsListMutation();
  const [getAssignmentClasses] = useGetAssignmentClassesMutation();
  const [searchString, setSearchString] = useState('');
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchString);
  const [initial, setInitial] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [skip, setSkip] = useState(0);
  const [studentName, setStudentName] = useState('');
  const [className, setClassName] = useState('');
  const [selectedStudentId, setSelectedStudentId] = useState(0);
  const [selectedClassId, setSelectedClassId] = useState(-1);
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [studentToIncludeTab, setStudentToIncludeTab] = useState(2);
  const [assessmentName, setAssessmentName] = useState('');
  const { Id } = useParams();
  const navigate = useNavigate();
  const [getAssessmentt, {isLoading}] = useGetAssignmentBasicMutation();

  useEffect(() => {
    if(selectedStudentId > 0 && students.length > 0)
    {
      var student = students.filter(x=>x.id == selectedStudentId);
      if(student?.length==1)
        setStudentName(student[0].name);
    }
  }, [selectedStudentId]);


  useEffect(() => {
    if (Id > 0) {
      getAssessmentAsync(Id);
      getAssignmentStudentsAsync(Id, 0, takeSize, true, []);
      setInitial(false);
    }
  }, [Id]);

  useEffect(() => {
    if (!initial) {
      const handler = setTimeout(() => {
        setSearchString(debouncedSearchText);
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [debouncedSearchText]);

  useEffect(() => {
    if (!initial) {
      getAssignmentStudentsAsync(Id, 0, takeSize, true, []);
    }
  }, [searchString]);

  const getAssessmentAsync = async (assignmentId) => {
    const option = {
      assignmentId: assignmentId
    };
    var assessment = await getAssessmentt(option).unwrap();
    setAssessmentName(assessment?.name);
  };

  const getAssignmentStudentsAsync = async (Id, skip, take, hasMore, students) => {
    if (hasMore) {
      const options = {
        assignmentId: Id,
        skip: skip,
        take: take,
        isAssessment: true,
        getOnlyTimeOnTask: false,
        searchString: searchString,
        isLoginReport: false
      };
      var response = await getAssignmentStudents(options).unwrap();
      setHasMore((skip + take) < response.total);
      if (response.data?.length > 0){
        var newStudents = [...students,...response.data];
        setStudents(newStudents);
        if(selectedStudentId>0)
        {
          var student = newStudents.find(x=>x.id == selectedStudentId);
          if(student)
          {
            setStudentName(student.name);
            setSelectedStudentId(student.id);
          }
        }
      }
      else{
        const noResults = [{ id: -2, name: 'No results found' }];
        setStudents(noResults);
        setSelectedStudentId(0);
        setStudentName('');
      }
    }
  };

  const getAssignmentClassesAsync = async (assignmentId) => {
    const options = {
      assignmentId: assignmentId,
      isAssessment: true,
      getOnlyTimeOnTask: false,
      isLoginReport: false
    };
    var classes = await getAssignmentClasses(options).unwrap();
    const obj = {
      id: -1,
      name: 'All Classes'
    };
    const classArray = [obj, ...classes];
    setClasses(classArray);
    const selectedClass = classArray.find(x=>x.id == selectedClassId);
    if(selectedClass)
      setClassName(selectedClass.name);
  };

  const handleTabSwitch = (tab) => {
    setSelectedClassId(-1);
    setClassName('All Classes');
    if (tab == 2) {
      setSearchString('');
      setStudentToIncludeTab(2);
      getAssignmentStudentsAsync(Id, 0, takeSize, true , []);
    }
    else if (tab == 0) {
      setStudentToIncludeTab(0);
    }
    else {
      setStudentToIncludeTab(1);
      getAssignmentClassesAsync(Id);
    }
  };

  const loadMoreData = () => {
    if (!initial && hasMore) {
      const skipValue = skip + takeSize;
      getAssignmentStudentsAsync(Id, skipValue, takeSize, hasMore, students);
      setSkip(skipValue);
    }
  };

  const handleReportPage =()=>{
    if(studentToIncludeTab == 2 && selectedStudentId == 0){
      CustomToast('Please select a student to create report.','error');
      return;
    }
    handleCreateReport();
  };

  const handleBack = ()=>{
    setStudentName('');
    window.history.back();
  };

  
  const handleCreateReport = ()=>{
    if(studentToIncludeTab == 2)
      navigate(`/assignments/${Id}/manage_assign/reports/student_session_report?studentId=${selectedStudentId}&incompleteScoring=${false}&studentsToInclude=${studentToIncludeTab}&assessmentReportType=1`);
    else
      navigate(`/assignments/${Id}/manage_assign/reports/class_cumulative_report?classId=${selectedClassId}&assessmentReportType=1`);
  }; 

  return (
    <>
      <div className='white-card'>
        {isLoading ?( 
          <>
            <SkeletonGrid
              rowCount={1}
              colCount={1}
              className={'p-2'}/>
            <SkeletonGrid
              rowCount={1}
              colCount={1}
              className={'mt-1 p-2'}/>
            <SkeletonGrid
              rowCount={1}
              colCount={3}
              className={'mt-5 p-2'}/>
          </>
        ):(
          <>
            <div className='align-items-center d-flex justify-content-between mb-4'>
              <h1 className='mb-4'>Single Assessment Report for : {assessmentName}</h1>
              <div>
                <button
                  onClick={() => handleBack()}
                  className="btn btn-castleWhite report-btn">
              Back
                </button>
              </div>
            </div>
            <p>The Single Assessment Report shows student performance for individual assessments or for all assessments in a course (currently assigned and unasssigned), providing a breakdown by various categoreis.</p>
        
            <Row>
              <Col className='col-10'>
                <Row className='mt-4 w-100'>
                  <Col className='col-5 px-2'>
                    <label className='mb-2'>Students To Include</label>
                    <Row className="d-flex align-items-center blueTabs w-100 mx-0">
                      <Col className={`justify-content-center btn ${studentToIncludeTab == 2 ? 'active' : ''}`} onClick={() => handleTabSwitch(2)}>Single Student</Col>
                      <Col className={`justify-content-center btn ${studentToIncludeTab == 0 ? 'active' : ''}`} onClick={() => handleTabSwitch(0)}>All Students</Col>
                      <Col className={`justify-content-center btn ${studentToIncludeTab == 1 ? 'active' : ''}`} onClick={() => handleTabSwitch(1)}>Students in Class</Col>
                    </Row>
                  </Col>
                  {studentToIncludeTab == 2 &&
            <Col className='col-5 px-2'>
              <label className='mb-2'>Student</label>
              <DropDownScroll
                value={students}
                selectedId={selectedStudentId}
                setSelectedId={setSelectedStudentId}
                dropdownId="studentList"
                selectedName={studentName}
                setSelectedName={setStudentName}
                loadMoreData={loadMoreData}
                isLoading={isStudentsLoading}
                setSearchString={setDebouncedSearchText}
              />
            </Col>
                  }
                  {studentToIncludeTab == 1 &&
            <Col className='col-5 px-2'>
              <label className='mb-2'>Class</label>
              <DropDownSelect
                value={classes}
                selectedId={selectedClassId}
                setSelectedId={setSelectedClassId}
                dropdownId="courseList"
                selectedName={className}
                setSelectedName={setClassName}
              />
            </Col>
                  }
                </Row>
              </Col>
              <div className='col-2 d-flex gap-3 mt-5 align-items-center'>
                <button className="w-100 btn btn-castleRed" onClick={()=>handleReportPage()}>
            Create Report
                </button>
              </div>
            </Row>
          </>
        )}
        
      </div>
    </>
  );
};

export default SingleAssessmentFilters;
